import anime from 'animejs';

let adventCalendar = () => {

  let module = {},
  today = new Date().getDate(),
  month = new Date().getMonth() + 1,
  currentDateContent,
  pathAnimations,
  pathMobileAnimations,
  starsAnimationSpeed = 900,
  easingType = 'easeInQuad',

  prepareMobileAnimatedHeroStars = () => {

    const path1 = anime.path('#mobile-animation-path-1');
    const animation1 = anime({
      targets: '#mobile-star-1',
      translateX: path1('x'),
      translateY: path1('y'),
      easing: easingType,
      duration: starsAnimationSpeed
    });
    animation1.pause()

    const path2 = anime.path('#mobile-animation-path-2');
    const animation2 = anime({
      targets: '#mobile-star-2',
      translateX: path2('x'),
      translateY: path2('y'),
      easing: easingType,
      duration: starsAnimationSpeed
    });
    animation2.pause()

    const path3 = anime.path('#mobile-animation-path-3');
    const animation3 = anime({
      targets: '#mobile-star-3',
      translateX: path3('x'),
      translateY: path3('y'),
      easing: easingType,
      duration: starsAnimationSpeed
    });
    animation3.pause()

    const path4 = anime.path('#mobile-animation-path-4');
    const animation4 = anime({
      targets: '#mobile-star-4',
      translateX: path4('x'),
      translateY: path4('y'),
      easing: easingType,
      duration: starsAnimationSpeed
    });
    animation4.pause()

    const path5 = anime.path('#mobile-animation-path-5');
    const animation5 = anime({
      targets: '#mobile-star-5',
      translateX: path5('x'),
      translateY: path5('y'),
      easing: easingType,
      duration: starsAnimationSpeed
    });
    animation5.pause()

    const path6 = anime.path('#mobile-animation-path-6');
    const animation6 = anime({
      targets: '#mobile-star-6',
      translateX: path6('x'),
      translateY: path6('y'),
      easing: easingType,
      duration: starsAnimationSpeed
    });
    animation6.pause()

    const path7 = anime.path('#mobile-animation-path-7');
    const animation7 = anime({
      targets: '#mobile-star-7',
      translateX: path7('x'),
      translateY: path7('y'),
      easing: easingType,
      duration: starsAnimationSpeed
    });
    animation7.pause()

    const path8 = anime.path('#mobile-animation-path-8');
    const animation8 = anime({
      targets: '#mobile-star-8',
      translateX: path8('x'),
      translateY: path8('y'),
      easing: easingType,
      duration: starsAnimationSpeed
    });
    animation8.pause()

    const path9 = anime.path('#mobile-animation-path-9');
    const animation9 = anime({
      targets: '#mobile-star-9',
      translateX: path9('x'),
      translateY: path9('y'),
      easing: easingType,
      duration: starsAnimationSpeed
    });
    animation9.pause()

    const path10 = anime.path('#mobile-animation-path-10');
    const animation10 = anime({
      targets: '#mobile-star-10',
      translateX: path10('x'),
      translateY: path10('y'),
      easing: easingType,
      duration: starsAnimationSpeed
    });
    animation10.pause()

    const path11 = anime.path('#mobile-animation-path-11');
    const animation11 = anime({
      targets: '#mobile-star-11',
      translateX: path11('x'),
      translateY: path11('y'),
      easing: easingType,
      duration: starsAnimationSpeed
    });
    animation11.pause()

    const path12 = anime.path('#mobile-animation-path-12');
    const animation12 = anime({
      targets: '#mobile-star-12',
      translateX: path12('x'),
      translateY: path12('y'),
      easing: easingType,
      duration: starsAnimationSpeed
    });
    animation12.pause()

    const path13 = anime.path('#mobile-animation-path-13');
    const animation13 = anime({
      targets: '#mobile-star-13',
      translateX: path13('x'),
      translateY: path13('y'),
      easing: easingType,
      duration: starsAnimationSpeed
    });
    animation13.pause()

    const path14 = anime.path('#mobile-animation-path-14');
    const animation14 = anime({
      targets: '#mobile-star-14',
      translateX: path14('x'),
      translateY: path14('y'),
      easing: easingType,
      duration: starsAnimationSpeed
    });
    animation14.pause()

    pathMobileAnimations = [animation1, animation2, animation3, animation4, animation5, animation6, animation7, animation8, animation9, animation10, animation11, animation12, animation13, animation14]
  },

  prepareAnimatedHeroStars = () => {
    const path1 = anime.path('#animation-path-1');
    const animation1 = anime({
      targets: '#star1',
      translateX: path1('x'),
      translateY: path1('y'),
      easing: easingType,
      duration: starsAnimationSpeed
    });
    animation1.pause()

    const path2 = anime.path('#animation-path-2');
    const animation2 = anime({
      targets: '#star2',
      translateX: path2('x'),
      translateY: path2('y'),
      easing: easingType,
      duration: starsAnimationSpeed
    });
    animation2.pause()

    const path3 = anime.path('#animation-path-3');
    const animation3 = anime({
      targets: '#star3',
      translateX: path3('x'),
      translateY: path3('y'),
      easing: easingType,
      duration: starsAnimationSpeed
    });
    animation3.pause()

    const path4 = anime.path('#animation-path-4');
    const animation4 = anime({
      targets: '#star4',
      translateX: path4('x'),
      translateY: path4('y'),
      easing: easingType,
      duration: starsAnimationSpeed
    });
    animation4.pause()

    const path5 = anime.path('#animation-path-5');
    const animation5 = anime({
      targets: '#star5',
      translateX: path5('x'),
      translateY: path5('y'),
      easing: easingType,
      duration: starsAnimationSpeed
    });
    animation5.pause()

    const path6 = anime.path('#animation-path-6');
    const animation6 = anime({
      targets: '#star6',
      translateX: path6('x'),
      translateY: path6('y'),
      easing: easingType,
      duration: starsAnimationSpeed
    });
    animation6.pause()

    const path7 = anime.path('#animation-path-7');
    const animation7 = anime({
      targets: '#star7',
      translateX: path7('x'),
      translateY: path7('y'),
      easing: easingType,
      duration: starsAnimationSpeed
    });
    animation7.pause()

    const path8 = anime.path('#animation-path-8');
    const animation8 = anime({
      targets: '#star8',
      translateX: path8('x'),
      translateY: path8('y'),
      easing: easingType,
      duration: starsAnimationSpeed
    });
    animation8.pause()

    const path9 = anime.path('#animation-path-9');
    const animation9 = anime({
      targets: '#star9',
      translateX: path9('x'),
      translateY: path9('y'),
      easing: easingType,
      duration: starsAnimationSpeed
    });
    animation9.pause()

    const path10 = anime.path('#animation-path-10');
    const animation10 = anime({
      targets: '#star10',
      translateX: path10('x'),
      translateY: path10('y'),
      easing: easingType,
      duration: starsAnimationSpeed
    });
    animation10.pause()

    const path11 = anime.path('#animation-path-11');
    const animation11 = anime({
      targets: '#star11',
      translateX: path11('x'),
      translateY: path11('y'),
      easing: easingType,
      duration: starsAnimationSpeed
    });
    animation11.pause()

    const path12 = anime.path('#animation-path-12');
    const animation12 = anime({
      targets: '#star12',
      translateX: path12('x'),
      translateY: path12('y'),
      easing: easingType,
      duration: starsAnimationSpeed
    });
    animation12.pause()

    const path13 = anime.path('#animation-path-13');
    const animation13 = anime({
      targets: '#star13',
      translateX: path13('x'),
      translateY: path13('y'),
      easing: easingType,
      duration: starsAnimationSpeed
    });
    animation13.pause()

    const path14 = anime.path('#animation-path-14');
    const animation14 = anime({
      targets: '#star14',
      translateX: path14('x'),
      translateY: path14('y'),
      easing: easingType,
      duration: starsAnimationSpeed
    });
    animation14.pause()

    const path15 = anime.path('#animation-path-15');
    const animation15 = anime({
      targets: '#star15',
      translateX: path15('x'),
      translateY: path15('y'),
      easing: easingType,
      duration: starsAnimationSpeed
    });
    animation15.pause()

    const path16 = anime.path('#animation-path-16');
    const animation16 = anime({
      targets: '#star16',
      translateX: path16('x'),
      translateY: path16('y'),
      easing: easingType,
      duration: starsAnimationSpeed
    });
    animation16.pause()

    const path17 = anime.path('#animation-path-17');
    const animation17 = anime({
      targets: '#star17',
      translateX: path17('x'),
      translateY: path17('y'),
      easing: easingType,
      duration: starsAnimationSpeed
    });
    animation17.pause()

    const path18 = anime.path('#animation-path-18');
    const animation18 = anime({
      targets: '#star18',
      translateX: path18('x'),
      translateY: path18('y'),
      easing: easingType,
      duration: starsAnimationSpeed
    });
    animation18.pause()

    const path19 = anime.path('#animation-path-19');
    const animation19 = anime({
      targets: '#star19',
      translateX: path19('x'),
      translateY: path19('y'),
      easing: easingType,
      duration: starsAnimationSpeed
    });
    animation19.pause()

    const path20 = anime.path('#animation-path-20');
    const animation20 = anime({
      targets: '#star20',
      translateX: path20('x'),
      translateY: path20('y'),
      easing: easingType,
      duration: starsAnimationSpeed
    });
    animation20.pause()

    const path21 = anime.path('#animation-path-21');
    const animation21 = anime({
      targets: '#star21',
      translateX: path21('x'),
      translateY: path21('y'),
      easing: easingType,
      duration: starsAnimationSpeed
    });
    animation21.pause()

    const path22 = anime.path('#animation-path-22');
    const animation22 = anime({
      targets: '#star22',
      translateX: path22('x'),
      translateY: path22('y'),
      easing: easingType,
      duration: starsAnimationSpeed
    });
    animation22.pause()

    const path23 = anime.path('#animation-path-23');
    const animation23 = anime({
      targets: '#star23',
      translateX: path23('x'),
      translateY: path23('y'),
      easing: easingType,
      duration: starsAnimationSpeed
    });
    animation23.pause()

    pathAnimations = [animation1, animation2, animation3, animation4, animation5, animation6, animation7, animation8, animation9, animation10, animation11, animation12, animation13, animation14, animation15, animation16, animation17, animation18, animation19, animation20, animation21, animation22, animation23]
  },

  animateStars = () => {
    pathAnimations.forEach(pathAnimation => {
      pathAnimation.play();
    });
  },

  animateMobileStars = () => {
    pathMobileAnimations.forEach(pathAnimation => {
      pathAnimation.play();
    });
  },

  animateTitleByChar = (el) => {
    var delayInt = 0.07;
    var fadeSec = 1;

    var text = el.find("#original-intro-hero-text").text();
    console.log('text: ', text)
    var _html = '';

    var delay = 0.1;
    var chars = text.split("");
    for (var i = 0; i < chars.length; i++) {
      if (i === chars.length-1) {
        _html += '<span id="last-advent-animated-char" class="w" style="animation:goldWordAnimation ' + fadeSec + 's ease-in-out ' + delay + 's forwards;">' + chars[i] + '</span>';
      } else {
        _html += '<span class="w" style="animation:goldWordAnimation ' + fadeSec + 's ease-in-out ' + delay + 's forwards;">' + chars[i] + '</span>';
      }
      delay += delayInt;
    }
    el.find(".intro-hero-title #animated-characters").html(_html);
  },

  // scrollToElement = (el, speed) => {
  //   $('.scrollable-container').delay(900).animate({
  //       scrollTop: $(el).offset().top - $(window).height()/2.5
  //   }, speed);
  // },

  attachButtonOpenAdvent = () => {
    $('#open-advent-btn').on('click', () => {
      animateMobileStars();
      animateStars();
      startAdvent();
      $('.scrollable-container').removeClass('overflow-hidden'); // inner content of the page becomes scrollable
      $('.decorative-frame-container').addClass('scroll-padding-right'); // add some padding to decorative frame on desktop after scrollbar appears
      $('#desktop-advent-svg').removeClass('hide-under-intro'); // desktop advent calendar becomes clickable
      $('#desktop-animated-hero-stars').addClass('transition-to-top'); // transition stars to align to the top of the page
      $('#advent-calendar-intro-footer').addClass('animate-down-out'); // animate intro footer out of the viewport and replace with a static one

      // if (today < 25) { // animate scroll to current date
      //   if ($(window).width() > 767) scrollToElement(`#date${today}`, 1200);
      //   else scrollToElement(`#mobile-date-${today}`, 1200);
      // }
    });
  },

  startAdvent = () => {
    $('#advent-hero-main-content').addClass('fade-out');
    $('#desktop-advent-svg').removeClass('opacity-zero');
    $('#mobile-advent-container').removeClass('opacity-zero');
    $('#advent-hero-after').addClass('visible');
  },

  closeModal = () => {
    $('.modal-overlay').removeClass('open-modal');
    $('.modal-overlay').addClass('closed-modal');
    $('.advent-modal').removeClass('open');
    $('.header-anchor').removeClass('lower-opacity');

    currentDateContent.addClass('hidden-date-sepcific-content');
  },

  openModal = (date) => {
    $('.modal-overlay').removeClass('initial-closed-state closed-modal');
    $('.modal-overlay').addClass('open-modal');
    $('.advent-modal').addClass('open');
    $('.header-anchor').addClass('lower-opacity');

    if (date <= today && month == 12) {
      currentDateContent = $(`#modal-content-${date}`);
    } else {
      currentDateContent = $('#modal-content-future');
    }
    currentDateContent.removeClass('hidden-date-sepcific-content');
  },

  attachClickListeners = () => {
    // close modal event clicks:
    $('.close-modal-btn').on('click', () => {
      closeModal();
    });
    $('.modal-overlay').on('click', () => {
      closeModal();
    });
    $('#close-btn').on('click', () => {
      closeModal();
    });

    // color active (past and today) desktop date buttons and set click listeners
    $('.date-circle-container').each((i, button) => {
      const buttonDate = button.id.replace("date", "");
      if (buttonDate <= today && month == 12) button.classList.add('date-active');
      button.addEventListener('click', () => {
        openModal(buttonDate); // pass clicked date
      });
    });

    // color active (past and today) mobile date buttons and set click listeners
    $('.date-btn').each((i, button) => {
      if (i+1 <= today && month == 12) button.classList.add('date-active');
      button.addEventListener('click', () => {
        openModal(i+1) // pass clicked date
      });
    });
  },

  init = () => {
    $(() => {
      if( $('.advent-container').length ) {
        attachClickListeners();
        prepareAnimatedHeroStars();
        prepareMobileAnimatedHeroStars();
        animateTitleByChar($("#advent-hero-main-content"));
        // setTimeout(() => {
        //   $('#text-after-animation').addClass('show-original-text');
        //   $('#animated-characters').addClass('d-none');
        // }, 4400);

		// FB sharer mod
		$(".advent-modal .share-btn").each(function() {
			let url = window.location.href.split('?');
			
			let pageurl = url[0].replace(/\/$/,'') + '/day' + $(this).data("dayindex") + '/' ;
			
			if (typeof(url[1]) !== 'undefined') {
				pageurl += '?' + url[1];
			}

			$(this).attr("href", "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent( pageurl ) +'&quote=' + encodeURIComponent($(this).data("dayquote")) );
		});

        const stars = document.querySelectorAll('.star')
        stars.forEach((star) => {
          star.classList.add('opacity-full');
        });
        attachButtonOpenAdvent();
      }
    });
  };

  module.init = init;

  return module;

};

export default adventCalendar();